module.exports = __webpack_public_path__ + "img/LisbethBengtsson.86ce57d2.jpg";